export const hasFlexboxSupport = () => {
  const element = document.createElement('b')
  element.style.display = 'flex'
  return element.style.display === 'flex'
}

export const isTouch = () =>
  'ontouchstart' in window || navigator.maxTouchPoints !== 0 // works on most browsers // works on IE10/11 and Surfaces

export const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame

export const getScrollPosition = (element = document.documentElement) => {
  if (element.scrollTop === 0) {
    return document.body.scrollTop
  }

  return element.scrollTop
}

export const viewport = {
  width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
  height: Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  ),
}

export const detectIE = () => {
  var ua = window.navigator.userAgent

  var msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  var edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}



// WEBPACK FOOTER //
// src/assets/js/front-end/common/browser.js